import { render } from "./ForgotUsername.vue?vue&type=template&id=a0042b3a"
import script from "./ForgotUsername.vue?vue&type=script&lang=js"
export * from "./ForgotUsername.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__